import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./ProfileSection.css";

function ProfileSection() {
  return (
    <div className="hero-container">
      {/* tag below add image for homepage */}
      <video src="/videos/bundle.mp4" autoPlay loop muted />
      <h1>GET READY TO CONNECT</h1>
      <p>What are you waiting for?</p>
      <div className="hero-btns">
        <Button
          className="btns"
          buttonStyle="btn--outline"
          buttonSize="btn--large"
        >
          GET STARTED
        </Button>
      </div>
    </div>
  );
}

export default ProfileSection;
